import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/foundation/initiatives/current/keeping_it_modern/report_library/",
      name: "Search",
      component: () =>
        import(/* webpackChunkName: "about" */ "./components/SearchKIM.vue")
    },
    {
      path:
        "/foundation/initiatives/current/keeping_it_modern/report_library/index.html",
      name: "SearchIndex",
      component: () =>
        import(/* webpackChunkName: "about" */ "./components/SearchKIM.vue")
    },
    {
      path:
        "/iw-mount/default/main/GettyPublic/WORKAREA/nhulea/foundation/initiatives/current/keeping_it_modern/report_library/",
      name: "SearchTeamSite",
      component: () =>
        import(/* webpackChunkName: "about" */ "./components/SearchKIM.vue")
    },
    {
      path:
        "/iw-mount/default/main/GettyPublic/WORKAREA/nhulea/foundation/initiatives/current/keeping_it_modern/report_library/index.html",
      name: "SearchTeamSiteIndex",
      component: () =>
        import(/* webpackChunkName: "about" */ "./components/SearchKIM.vue")
    }
  ]
});
